import { render, staticRenderFns } from "./DiscoveryTable.vue?vue&type=template&id=75a5339b&"
import script from "./DiscoveryTable.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports